// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/Payment_Invoice.jpeg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.download-btn {
  border-radius: 10px;
  padding: 5px;
  background-color: #f7f9fa;
  box-shadow: 0px 2px 8px 10px rgba(22, 21, 21, 0.1);
}

.invoice-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
}

.invoice-container {
  position: relative;
  width: 100%;
  max-width: 1200px;
  /* limit max width for better scaling */
  aspect-ratio: 8.5 / 11;
  /* maintains background aspect ratio (like A4) */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

/* Overlay for positioned text */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}


.payment-id {
  position: absolute;
  top: 8%;
  /* adjust according to image */
  left: 67.6%;
  font-size: 1.2vw;
  /* responsive font size */
  font-weight: bold;
}

.payment-date {
  position: absolute;
  top: 10%;
  /* adjust according to image */
  left: 67.6%;
  font-size: 1.2vw;
  /* responsive font size */
  font-weight: bold;
}

/* Positioning with % instead of px */
.trainee-name {
  position: absolute;
  top: 17.3%;
  /* adjust according to image */
  left: 11.7%;
  font-size: 1.1vw;
  /* responsive font size */
  font-weight: bold;
}

.trainee-roll-no {
  position: absolute;
  top: 22.5%;
  left: 11.7%;
  font-size: 1.1vw;
  font-weight: bold;
}

.trainee-branch {
  position: absolute;
  top: 22.6%;
  left: 30.2%;
  font-size: 1.1vw;
  font-weight: bold;
}

.trainee-college {
  position: absolute;
  top: 22.5%;
  left: 41.8%;
  font-size: 1.1vw;
  font-weight: bold;
}

.trainee-passout {
  position: absolute;
  top: 22.5%;
  left: 56%;
  font-size: 1.1vw;
  font-weight: bold;
}

.name-of-the-track {
  position: absolute;
  top: 29.5%;
  left: 11.7%;
  font-size: 1.1vw;
  font-weight: bold;
}

.name-of-the-course {
  position: absolute;
  top: 29.5%;
  left: 41.8%;
  font-size: 1.1vw;
  font-weight: bold;
}

.amount-paid {
  position: absolute;
  top: 34.9%;
  left: 13.5%;
  font-size: 1.1vw;
  font-weight: bold;
}

.the-term {
  position: absolute;
  top: 34.9%;
  left: 42%;
  font-size: 1.1vw;
  font-weight: bold;
}

.cashier-name {
  position: absolute;
  top: 43%;
  left: 75%;
  /* ← starts right under SIGNATURE label */
  font-size: 1vw;
  /* ← smaller font so long names fit in one line */
  font-weight: bold;
  white-space: nowrap;
  /* ← never wraps, stays single line */
  width: auto;
  overflow: visible;
}

/* Make sure it scales nicely on smaller screens */
@media (max-width: 768px) {
  .invoice-container {
    max-width: 95%;
  }

  .overlay h2 {
    font-size: 3vw;
  }
}






.payment-id-1 {
  position: absolute;
  top: 57.6%;
  left: 67.6%;
  font-size: 1.2vw;
  font-weight: bold;
}

.payment-date-1 {
  position: absolute;
  top: 59.6%;
  left: 67.6%;
  font-size: 1.2vw;
  font-weight: bold;
}


/* Positioning with % instead of px */
.trainee-name-1 {
  position: absolute;
  top: 67.4%;
  /* adjust according to image */
  left: 11.7%;
  font-size: 1.2vw;
  /* responsive font size */
  font-weight: bold;
}

.trainee-roll-no-1 {
  position: absolute;
  top: 72.5%;
  left: 11.7%;
  font-size: 1.2vw;
  font-weight: bold;
}

.trainee-branch-1 {
  position: absolute;
  top: 72.5%;
  left: 30.2%;
  font-size: 1.2vw;
  font-weight: bold;
}

.trainee-college-1 {
  position: absolute;
  top: 72.5%;
  left: 41.8%;
  font-size: 1.2vw;
  font-weight: bold;
}

.name-of-the-track-1 {
  position: absolute;
  top: 79.5%;
  left: 11.7%;
  font-size: 1.2vw;
  font-weight: bold;
}

.name-of-the-course-1 {
  position: absolute;
  top: 79.5%;
  left: 41.8%;
  font-size: 1.2vw;
  font-weight: bold;
}

.amount-paid-1 {
  position: absolute;
  top: 84.9%;
  left: 13.5%;
  font-size: 1.2vw;
  font-weight: bold;
}

.the-term-1 {
  position: absolute;
  top: 84.9%;
  left: 42%;
  font-size: 1.2vw;
  font-weight: bold;
}

.trainee-passout-1 {
  position: absolute;
  top: 72.5%;
  left: 56%;
  font-size: 1.1vw;
  font-weight: bold;
}

.cashier-name-1 {
  position: absolute;
  top: 93.1%;
  left: 75%;
  /* ← same as above */
  font-size: 1vw;
  /* ← smaller font */
  font-weight: bold;
  white-space: nowrap;
  /* ← never wraps */
  width: auto;
  overflow: visible;
}

/* Make sure it scales nicely on smaller screens */
@media (max-width: 768px) {
  .invoice-container-1 {
    max-width: 95%;
  }

  .overlay-1 h2 {
    font-size: 0.01vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/CoursePayments/invoice.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,uCAAuC;EACvC,sBAAsB;EACtB,gDAAgD;EAChD,yDAA6D;EAC7D,wBAAwB;EACxB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,kBAAkB;EAClB,OAAO;EACP,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,UAAU;EACV,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,yCAAyC;EACzC,cAAc;EACd,iDAAiD;EACjD,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,WAAW;EACX,iBAAiB;AACnB;;AAEA,kDAAkD;AAClD;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;;;;;;AAOA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;;AAGA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,UAAU;EACV,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA,kDAAkD;AAClD;EACE;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".download-btn {\r\n  border-radius: 10px;\r\n  padding: 5px;\r\n  background-color: #f7f9fa;\r\n  box-shadow: 0px 2px 8px 10px rgba(22, 21, 21, 0.1);\r\n}\r\n\r\n.invoice-wrapper {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 2rem;\r\n}\r\n\r\n.invoice-container {\r\n  position: relative;\r\n  width: 100%;\r\n  max-width: 1200px;\r\n  /* limit max width for better scaling */\r\n  aspect-ratio: 8.5 / 11;\r\n  /* maintains background aspect ratio (like A4) */\r\n  background-image: url(\"../../../public/Payment_Invoice.jpeg\");\r\n  background-size: contain;\r\n  background-repeat: no-repeat;\r\n  background-position: center;\r\n}\r\n\r\n/* Overlay for positioned text */\r\n.overlay {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n\r\n.payment-id {\r\n  position: absolute;\r\n  top: 8%;\r\n  /* adjust according to image */\r\n  left: 67.6%;\r\n  font-size: 1.2vw;\r\n  /* responsive font size */\r\n  font-weight: bold;\r\n}\r\n\r\n.payment-date {\r\n  position: absolute;\r\n  top: 10%;\r\n  /* adjust according to image */\r\n  left: 67.6%;\r\n  font-size: 1.2vw;\r\n  /* responsive font size */\r\n  font-weight: bold;\r\n}\r\n\r\n/* Positioning with % instead of px */\r\n.trainee-name {\r\n  position: absolute;\r\n  top: 17.3%;\r\n  /* adjust according to image */\r\n  left: 11.7%;\r\n  font-size: 1.1vw;\r\n  /* responsive font size */\r\n  font-weight: bold;\r\n}\r\n\r\n.trainee-roll-no {\r\n  position: absolute;\r\n  top: 22.5%;\r\n  left: 11.7%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n}\r\n\r\n.trainee-branch {\r\n  position: absolute;\r\n  top: 22.6%;\r\n  left: 30.2%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n}\r\n\r\n.trainee-college {\r\n  position: absolute;\r\n  top: 22.5%;\r\n  left: 41.8%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n}\r\n\r\n.trainee-passout {\r\n  position: absolute;\r\n  top: 22.5%;\r\n  left: 56%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n}\r\n\r\n.name-of-the-track {\r\n  position: absolute;\r\n  top: 29.5%;\r\n  left: 11.7%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n}\r\n\r\n.name-of-the-course {\r\n  position: absolute;\r\n  top: 29.5%;\r\n  left: 41.8%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n}\r\n\r\n.amount-paid {\r\n  position: absolute;\r\n  top: 34.9%;\r\n  left: 13.5%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n}\r\n\r\n.the-term {\r\n  position: absolute;\r\n  top: 34.9%;\r\n  left: 42%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n}\r\n\r\n.cashier-name {\r\n  position: absolute;\r\n  top: 43%;\r\n  left: 75%;\r\n  /* ← starts right under SIGNATURE label */\r\n  font-size: 1vw;\r\n  /* ← smaller font so long names fit in one line */\r\n  font-weight: bold;\r\n  white-space: nowrap;\r\n  /* ← never wraps, stays single line */\r\n  width: auto;\r\n  overflow: visible;\r\n}\r\n\r\n/* Make sure it scales nicely on smaller screens */\r\n@media (max-width: 768px) {\r\n  .invoice-container {\r\n    max-width: 95%;\r\n  }\r\n\r\n  .overlay h2 {\r\n    font-size: 3vw;\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n.payment-id-1 {\r\n  position: absolute;\r\n  top: 57.6%;\r\n  left: 67.6%;\r\n  font-size: 1.2vw;\r\n  font-weight: bold;\r\n}\r\n\r\n.payment-date-1 {\r\n  position: absolute;\r\n  top: 59.6%;\r\n  left: 67.6%;\r\n  font-size: 1.2vw;\r\n  font-weight: bold;\r\n}\r\n\r\n\r\n/* Positioning with % instead of px */\r\n.trainee-name-1 {\r\n  position: absolute;\r\n  top: 67.4%;\r\n  /* adjust according to image */\r\n  left: 11.7%;\r\n  font-size: 1.2vw;\r\n  /* responsive font size */\r\n  font-weight: bold;\r\n}\r\n\r\n.trainee-roll-no-1 {\r\n  position: absolute;\r\n  top: 72.5%;\r\n  left: 11.7%;\r\n  font-size: 1.2vw;\r\n  font-weight: bold;\r\n}\r\n\r\n.trainee-branch-1 {\r\n  position: absolute;\r\n  top: 72.5%;\r\n  left: 30.2%;\r\n  font-size: 1.2vw;\r\n  font-weight: bold;\r\n}\r\n\r\n.trainee-college-1 {\r\n  position: absolute;\r\n  top: 72.5%;\r\n  left: 41.8%;\r\n  font-size: 1.2vw;\r\n  font-weight: bold;\r\n}\r\n\r\n.name-of-the-track-1 {\r\n  position: absolute;\r\n  top: 79.5%;\r\n  left: 11.7%;\r\n  font-size: 1.2vw;\r\n  font-weight: bold;\r\n}\r\n\r\n.name-of-the-course-1 {\r\n  position: absolute;\r\n  top: 79.5%;\r\n  left: 41.8%;\r\n  font-size: 1.2vw;\r\n  font-weight: bold;\r\n}\r\n\r\n.amount-paid-1 {\r\n  position: absolute;\r\n  top: 84.9%;\r\n  left: 13.5%;\r\n  font-size: 1.2vw;\r\n  font-weight: bold;\r\n}\r\n\r\n.the-term-1 {\r\n  position: absolute;\r\n  top: 84.9%;\r\n  left: 42%;\r\n  font-size: 1.2vw;\r\n  font-weight: bold;\r\n}\r\n\r\n.trainee-passout-1 {\r\n  position: absolute;\r\n  top: 72.5%;\r\n  left: 56%;\r\n  font-size: 1.1vw;\r\n  font-weight: bold;\r\n}\r\n\r\n.cashier-name-1 {\r\n  position: absolute;\r\n  top: 93.1%;\r\n  left: 75%;\r\n  /* ← same as above */\r\n  font-size: 1vw;\r\n  /* ← smaller font */\r\n  font-weight: bold;\r\n  white-space: nowrap;\r\n  /* ← never wraps */\r\n  width: auto;\r\n  overflow: visible;\r\n}\r\n\r\n/* Make sure it scales nicely on smaller screens */\r\n@media (max-width: 768px) {\r\n  .invoice-container-1 {\r\n    max-width: 95%;\r\n  }\r\n\r\n  .overlay-1 h2 {\r\n    font-size: 0.01vw;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
